"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Popper = require("popper.js");
var $ = require("jquery");
window.jQuery = $;
window.$ = $;
window.Popper = Popper;
require("bootstrap");
var scroller_1 = require("./scroller");
var resizer_1 = require("./resizer");
var link_handler_1 = require("./link-handler");
var swiper_1 = require("./components/swiper");
var client_path_1 = require("./client-path");
scroller_1.Scroller.scrollClientSiteToTopIfNeeded();
$(function () {
    client_path_1.ClientPath.updateClientPath();
    resizer_1.Resizer.setup();
    link_handler_1.LinkHandler.setup();
    swiper_1.MallWebSwiper.setup();
});
